import type { Routes } from "@angular/router";
import { MainLayoutComponent } from "@layout/main-layout/main-layout.component";

export default [
	{
		path: "counselling",
		component: MainLayoutComponent,
		children: [
			{
				path: "",
				loadComponent: () =>
					import("./counselling.component").then((c) => c.CounsellingComponent),
			},
		],
	},
] satisfies Routes;
